export const CAMERA_STATUS = Object.freeze({
  NO_DEVICE: 'no_device',
  PERMISSION_DENIED: 'permission_denied',
  DEVICE_UNAVAILABLE: 'device_unavailable',
  GET_USER_MEDIA_ERROR: 'get_user_media_error',
  RECORDING_STARTED: 'recording_started',
  RECORDING_ERROR: 'recording_error',
  UPLOAD_CHUNK_FAILED: 'upload_chunk_failed',
  UPLOAD_COMPLETED: 'upload_completed',
  UPLOAD_FAILED: 'upload_failed',
  RECORDING_STOPPED_NORMAL: 'recording_stopped_normal',
  RECORDING_STOPPED_TIMEOUT: 'recording_stopped_timeout',
})

export const CAMERA_ERROR_CODES = Object.freeze({
  CAMERA_REQUIRED: 'camera_required',
})

export const CAMERA_STOP_REASON = Object.freeze({
  ROUTE_CHANGE: 'route_change',
  NEXT_ORDER: 'next_order',
  TOTE_SEARCH: 'tote_search',
  MAX_DURATION: 'max_duration',
  MANUAL: 'manual',
  UNMOUNT: 'unmount',
  FAILURE: 'failure',
})

export const STATUSES_INDICATING_NO_RECORDING = Object.freeze([
  CAMERA_STATUS.NO_DEVICE,
  CAMERA_STATUS.PERMISSION_DENIED,
  CAMERA_STATUS.DEVICE_UNAVAILABLE,
  CAMERA_STATUS.GET_USER_MEDIA_ERROR,
  CAMERA_STATUS.UPLOAD_FAILED,
  CAMERA_STATUS.RECORDING_STOPPED_NORMAL,
  CAMERA_STATUS.RECORDING_STOPPED_TIMEOUT,
])
